import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Widget from '@/components/widget/Widget'
import { PageHeader } from '@/components/headers/PageHeader'
import { QAAnalystActivityWidget } from '@/views/Scorecards/QAAnalystActivity/QAAnalystActivityWidget'
import { SavedFilters } from '@/components/savedFilters/SavedFilters'
import {
  QA_ACTIVITY_FILTER_TYPE,
  COPILOT_FILTER_TYPE,
} from '@/reducers/savedFilters/savedFilters.constants'
import { loadQAActivityDefaultFilters } from '@/reducers/scorecards/scores.actions'
import { setFilter, setDateRangeFilter } from '@/reducers/scorecards/scorecards.redux'
import { getDateRangeFromSavedFilter } from '@/utils/helpers'
import { FiltersSection } from './sections/FiltersSection'
import { TableSection } from './sections/TableSection'

const SAVED_FILTER_FORM_OPTIONS = [
  'name',
  'isDefault',
  'dateRange',
  'scorecards',
  'playlists',
  'agents',
]

export const QAActivityPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { data = {}, loading = {}, filters = {} } = useSelector((state) => state.scorecards || {})
  const { savedFilterList } = useSelector((state) => state.savedFilters)
  const [selectedSavedFilterId, setSelectedSavedFilterId] = useState(null)

  const isCopilot = location.pathname.startsWith('/qa-copilot/')
  const filterType = isCopilot ? COPILOT_FILTER_TYPE : QA_ACTIVITY_FILTER_TYPE

  const applySavedFilter = (savedFilter) => {
    const filterData = savedFilter?.filters || {}
    dispatch(setFilter('managerIds', filterData.agents || []))
    dispatch(setFilter('scorecards', filterData.scorecards || []))
    dispatch(setFilter('playlists', filterData.playlists || []))

    if (filterData.dateRange) {
      const { startDate, endDate } = getDateRangeFromSavedFilter(filterData.dateRange)
      dispatch(setDateRangeFilter({ startDate, endDate }))
    }
  }

  const handleSelectSavedFilter = (value) => {
    setSelectedSavedFilterId(value || null)

    if (value) {
      const allFilters = savedFilterList[filterType] || []
      const fullFilter = allFilters.find((savedFilter) => savedFilter.uuid === value)
      applySavedFilter(fullFilter)
    } else {
      applySavedFilter(null)
    }
  }

  useEffect(() => {
    dispatch(loadQAActivityDefaultFilters(isCopilot)).then((defaultFilter) => {
      if (defaultFilter) {
        setSelectedSavedFilterId(defaultFilter.uuid)
      }
    })
  }, [])

  const isLoading = loading.managerAudit || loading.qaAnalystActivity || loading.callViewCounts

  return (
    <div data-testid="scorecard-exports-dashboard">
      <PageHeader
        title="QA Activity"
        actions={
          <SavedFilters
            filterType={filterType}
            filterFormOptions={SAVED_FILTER_FORM_OPTIONS}
            selectedSavedFilterId={selectedSavedFilterId}
            handleSelectSavedFilter={handleSelectSavedFilter}
          />
        }
      />

      <FiltersSection />

      <Widget
        widgetId="qa-activity"
        label="QA Activity"
        subtitle="Showing QA analyst scoring and dispute activity"
        tableOnly
        showCsvDownload
      >
        <QAAnalystActivityWidget
          managerAuditData={data.managerAudit || []}
          analystActivityData={data.qaAnalystActivity || []}
          callViewCountsData={data.callViewCounts || []}
          loading={isLoading}
          organizationId={filters.organization}
        />
      </Widget>

      <TableSection />
    </div>
  )
}

export default QAActivityPage
